module.exports = __webpack_public_path__ + "images/munsterhuis856140226d5af2d954c7c39a36c9603b.png";